import { render } from "./HowItWorksSection.vue?vue&type=template&id=cb3adb1c&scoped=true"
import script from "./HowItWorksSection.vue?vue&type=script&lang=js"
export * from "./HowItWorksSection.vue?vue&type=script&lang=js"

import "./HowItWorksSection.vue?vue&type=style&index=0&id=cb3adb1c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3adb1c"]])

export default __exports__